// Generated by the TanStack Router Rspack plugin (see rspack.config.ts).
import { queryClient } from '@/app/queryClient';
import { routeTree } from '@/routeTree.gen';
import { SystemRouteErrorState } from '@/shared/components/SystemRouteErrorState';
import { createRouter } from '@tanstack/react-router';

// Provide the query client as typed router context so `beforeLoad` permission
// guards can resolve permissions before a route loads (see routeGuards.ts).
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultErrorComponent: SystemRouteErrorState,
  defaultPendingMs: 0,
  defaultPendingMinMs: 0,
});
